import template from "./review_modal.html";
import en from "./en.json";
import es from "./es.json";
import moment from "moment";
import _ from "lodash";

const ENGAGEMENT_MODAL_STORAGE_KEY = "showReviewBanner";
const COOL_OFF_DAYS = 60;
const LEGACY_COOL_OFF_DAYS = 30;

class EngagementModalController {
    /* @ngInject */
    constructor(localStorageService, $element, $scope) {
        this.localStorageService = localStorageService;
        this.$element = $element;
        this.$scope = $scope;
    }

    $onInit() {
        let ctrl = this;
        ctrl.visible = ctrl.shouldDisplay();
    }

    isReviewPopup() {
        let ctrl = this;
        return ctrl.popupType === "review";
    }

    isReferralPopup() {
        let ctrl = this;
        return ctrl.popupType === "referral";
    }

    shouldDisplay() {
        let ctrl = this;
        let lastHiddenDate = ctrl.getStoredTimestamp();
        return moment().diff(lastHiddenDate, "days") >= COOL_OFF_DAYS;
    }

    getStoredTimestamp() {
        let ctrl = this;
        let storedValue = ctrl.localStorageService.get(
            ENGAGEMENT_MODAL_STORAGE_KEY,
        );
        if (typeof storedValue === "boolean") {
            let legacyTimestamp = moment()
                .subtract(LEGACY_COOL_OFF_DAYS, "days")
                .toISOString();
            ctrl.localStorageService.set(
                ENGAGEMENT_MODAL_STORAGE_KEY,
                legacyTimestamp,
            );
            storedValue = ctrl.localStorageService.get(
                ENGAGEMENT_MODAL_STORAGE_KEY,
            );
        }

        let referenceDate;
        if (moment(storedValue).isValid()) {
            referenceDate = moment(storedValue);
        } else {
            referenceDate = moment()
                .subtract(COOL_OFF_DAYS + 1, "days")
                .toISOString();
        }
        return moment(referenceDate);
    }

    handleClose() {
        let ctrl = this;
        ctrl.localStorageService.set(
            ENGAGEMENT_MODAL_STORAGE_KEY,
            moment().toISOString(),
        );
        ctrl.visible = false;
        ctrl.$scope.$evalAsync(function () {
            ctrl.$element.remove();
            ctrl.$scope.$destroy();
        });
    }
}

export default {
    template: template,
    controller: EngagementModalController,
    bindings: {
        popupType: "@",
    },
    name: "engagementModal",
    translations: { en, es },
};
